import { getFetch, postFetchWithBody, postFetchWithToken } from "../../utils/fetch";

async function getMachines({ page="page=1", term = "" }) {
  const data = await getFetch(`/Machines?${page}&name=${term}`);
  if (data.status !== "error") {
    return {
      status: "success",
      message: data,
    };
  } else {
    return {
      status: data.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}
async function storeMachine(form) {
  if (!form.title || form.title === '') {
    return {
      status: 'error',
      message: 'عنوان الزامی است!',
    };
  }
  if (!form.pelak || form.pelak === '') {
    return {
      status: 'error',
      message: 'پلاک الزامی است!',
    };
  }

  const res = await postFetchWithBody("/Machines/store", form);
  if(res.status !== 'error'){
    return {
      status:'success',
      message:'دستگاه با موفقیت ایجاد شد'
    }
  }else{
    return {
      status:res.status,
      message:res.message
    }
  }

}

async function updateMachine(form) {
  if (!form.title || form.title === '') {
    return {
      status: 'error',
      message: 'عنوان الزامی است!',
    };
  }
  if (!form.pelak || form.pelak === '') {
    return {
      status: 'error',
      message: 'پلاک الزامی است!',
    };
  }
  const res = await postFetchWithBody("/Machines/update", form);
  if(res.status !== 'error'){
    return {
      status:'success',
      message:'دستگاه با موفقیت ویرایش شد'
    }
  }else{
    return {
      status:res.status,
      message:res.message
    }
  }

}
async function deleteMachine(id) {
  const res = await postFetchWithBody(`/Machines/delete`, { id: id });
  if (res.status !== "error") {
    return {
      status: "success",
      message: res,
    };
  } else {
    return {
      status: res.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}
export { getMachines , storeMachine, updateMachine, deleteMachine};
